var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useCallback, useState } from 'react';
import { ValidateMagicPhraseView } from './View';
import useAsyncEffect from 'hooks/useAsyncEffect';
import { useNavigate } from 'react-router';
import { StepEnum } from '../../../Enums/StepEnum';
import { colors } from 'designSystem/theme/colors';
var kiteString = "<svg xmlns=\"http://www.w3.org/2000/svg\" color=\"inherit\" width=\"49\" height=\"48\" viewBox=\"0 0 49 48\" fill=\"none\">\n<g clip-path=\"url(#clip0_5454_46508)\">\n  <path d=\"M34.262 32.5384C34.1258 32.7493 33.939 32.9227 33.7185 33.0429C33.4981 33.163 33.251 33.2259 33 33.2259C32.7489 33.2259 32.5019 33.163 32.2814 33.0429C32.061 32.9227 31.8741 32.7493 31.738 32.5384L20.738 14.5804C20.5452 14.2793 20.466 13.9194 20.5148 13.5653C20.5635 13.2112 20.737 12.8861 21.004 12.6484L32.004 1.87835C32.2792 1.63279 32.6351 1.49707 33.004 1.49707C33.3728 1.49707 33.7288 1.63279 34.004 1.87835L45.004 12.6484C45.271 12.8861 45.4444 13.2112 45.4932 13.5653C45.5419 13.9194 45.4628 14.2793 45.27 14.5804L34.262 32.5384Z\" stroke=\"currentColor\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  <path d=\"M20.52 13.5H45.48\" stroke=\"currentColor\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  <path d=\"M3 46.5L6.964 42.536C8.44335 41.0567 10.339 40.0641 12.3976 39.691C14.4561 39.3179 16.5796 39.582 18.484 40.448C19.7663 41.0307 21.1547 41.3437 22.563 41.3676C23.9713 41.3914 25.3695 41.1256 26.6708 40.5866C27.9721 40.0477 29.1487 39.247 30.1278 38.2344C31.1068 37.2218 31.8672 36.0188 32.362 34.7L33 33.226V1.5\" stroke=\"currentColor\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n</g>\n<defs>\n  <clipPath id=\"clip0_5454_46508\">\n    <rect width=\"48\" height=\"48\" fill=\"white\" transform=\"translate(0.5)\"/>\n  </clipPath>\n</defs>\n</svg>";
var cloverString = "<svg color=\"inherit\" xmlns=\"http://www.w3.org/2000/svg\" width=\"49\" height=\"50\" viewBox=\"0 0 49 50\" fill=\"none\">\n<path d=\"M37.8 18.426L24.5 19.946L25.86 6.50603C25.9926 5.18525 26.6445 3.97125 27.6722 3.13108C28.6999 2.29092 30.0192 1.89342 31.34 2.02603C32.6608 2.15864 33.8748 2.81049 34.7149 3.83819C35.5551 4.86589 35.9526 6.18525 35.82 7.50603L35.7 8.60603L36.68 8.48603C37.9981 8.33751 39.3213 8.71869 40.3583 9.54573C41.3954 10.3728 42.0615 11.5779 42.21 12.896C42.3585 14.2142 41.9773 15.5373 41.1503 16.5744C40.3233 17.6114 39.1181 18.2775 37.8 18.426Z\" stroke=\"currentColor\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n<path d=\"M11.2 18.426L24.5 19.946L23.14 6.50603C23.0074 5.18525 22.3556 3.97125 21.3279 3.13108C20.3002 2.29092 18.9808 1.89342 17.66 2.02603C16.3392 2.15864 15.1252 2.81049 14.2851 3.83819C13.4449 4.86589 13.0474 6.18525 13.18 7.50603L13.3 8.60603L12.32 8.48603C11.0019 8.33751 9.67875 8.71869 8.64167 9.54573C7.60459 10.3728 6.93853 11.5779 6.79001 12.896C6.64149 14.2142 7.02268 15.5373 7.84971 16.5744C8.67675 17.6114 9.88189 18.2775 11.2 18.426Z\" stroke=\"currentColor\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n<path d=\"M37.8 21.4663L24.5 19.9463L25.86 33.3863C25.9257 34.0403 26.1195 34.6749 26.4304 35.254C26.7414 35.8331 27.1633 36.3452 27.6722 36.7612C28.181 37.1772 28.7668 37.4889 29.3962 37.6786C30.0255 37.8682 30.686 37.932 31.34 37.8663C31.994 37.8006 32.6286 37.6068 33.2077 37.2959C33.7868 36.9849 34.2989 36.563 34.7149 36.0541C35.131 35.5453 35.4427 34.9594 35.6323 34.3301C35.8219 33.7008 35.8857 33.0403 35.82 32.3863L35.7 31.2863L36.68 31.4063C37.9981 31.5548 39.3213 31.1736 40.3583 30.3466C41.3954 29.5196 42.0615 28.3144 42.21 26.9963C42.3585 25.6782 41.9773 24.355 41.1503 23.3179C40.3233 22.2809 39.1181 21.6148 37.8 21.4663Z\" stroke=\"currentColor\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n<path d=\"M11.2 21.4663L24.5 19.9463L23.14 33.3863C23.0074 34.7071 22.3556 35.9211 21.3279 36.7612C20.3002 37.6014 18.9808 37.9989 17.66 37.8663C16.3392 37.7337 15.1252 37.0818 14.2851 36.0541C13.4449 35.0264 13.0474 33.7071 13.18 32.3863L13.3 31.2863L12.32 31.4063C11.0019 31.5548 9.67875 31.1736 8.64167 30.3466C7.60459 29.5196 6.93853 28.3144 6.79001 26.9963C6.64149 25.6782 7.02268 24.355 7.84971 23.3179C8.67675 22.2809 9.88189 21.6148 11.2 21.4663Z\" stroke=\"currentColor\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n<path d=\"M24.5 40V41C24.5 42.8565 25.2375 44.637 26.5503 45.9497C27.863 47.2625 29.6435 48 31.5 48\" stroke=\"currentColor\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n</svg>";
var res = {
    "data": {
        "getMagicPhraseOptions": {
            "animals": [
                {
                    "name": "Kite",
                    "enum": "KITE",
                    "image": kiteString
                },
                {
                    "name": "Clover",
                    "enum": "CLOVER",
                    "image": cloverString
                }
            ],
            "colors": [
                {
                    "name": "Coral",
                    "enum": "CORAL",
                    "hex": colors.coral.coral500,
                    "textColor": "#000000"
                },
                {
                    "name": "Teal",
                    "enum": "TEAL",
                    "hex": colors.teal.teal500,
                    "textColor": "#FFFFFF"
                }
            ]
        }
    }
};
export var ValidateMagicPhraseContainer = function (_a) {
    var _b;
    var phoneNumber = _a.phoneNumber, onRewardAction = _a.onRewardAction, handleRestart = _a.handleRestart, rewardAmount = _a.rewardAmount, initialVal = _a.initialVal, existingCheckInId = _a.existingCheckInId, magicPhraseSent = _a.magicPhraseSent, onForward = _a.onForward;
    var navigate = useNavigate();
    var _c = __read(useState({
        color: (initialVal === null || initialVal === void 0 ? void 0 : initialVal.color) || null,
        symbol: (initialVal === null || initialVal === void 0 ? void 0 : initialVal.animal) || null,
    }), 2), selectedPhrase = _c[0], setSelectedPhrase = _c[1];
    var _d = __read(useState('SMS'), 2), deliveryMethod = _d[0], setDeliveryMethod = _d[1];
    var _e = __read(useState(!magicPhraseSent), 2), retryMagicPhrase = _e[0], setRetryMagicPhrase = _e[1];
    var _f = __read(useState(null), 2), magicTriesLeft = _f[0], setMagicTriesLeft = _f[1];
    var _g = __read(useState(existingCheckInId !== null && existingCheckInId !== void 0 ? existingCheckInId : null), 2), setCheckInId = _g[1];
    var onContinue = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (magicTriesLeft === 0) {
                setMagicTriesLeft(null);
                setRetryMagicPhrase(true);
                return [2];
            }
            onForward();
            navigate(StepEnum.CheckInComplete);
            return [2];
        });
    }); };
    var sendPhrase = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var id;
        return __generator(this, function (_a) {
            try {
                id = 'testtest';
                onRewardAction(deliveryMethod === 'SMS' ? 'primary' : 'secondary');
                navigate(StepEnum.ValidateMagicPhrase);
            }
            catch (e) {
            }
            finally {
                setCheckInId(id);
                setSelectedPhrase({
                    color: null,
                    symbol: null,
                });
            }
            return [2];
        });
    }); }, [
        navigate,
        deliveryMethod,
        onRewardAction,
    ]);
    useAsyncEffect(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!retryMagicPhrase) return [3, 2];
                    setRetryMagicPhrase(false);
                    return [4, sendPhrase()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2];
            }
        });
    }); }, [retryMagicPhrase, sendPhrase]);
    return (React.createElement(ValidateMagicPhraseView, { handleRestart: handleRestart, onContinue: onContinue, setDeliveryMethod: setDeliveryMethod, magicTriesLeft: magicTriesLeft, selectedPhrase: selectedPhrase, setSelectedPhrase: setSelectedPhrase, setRetryMagicPhrase: setRetryMagicPhrase, onResend: function () {
            setMagicTriesLeft(null);
        }, phoneNumber: phoneNumber, rewardAmount: 40, sendLoading: false, loading: false, optionsLoading: false, options: (_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.getMagicPhraseOptions }));
};
